import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-pm-technical-suborder-kpi',
  templateUrl: './pm-technical-suborder-kpi.component.html',
  styleUrls: ['./pm-technical-suborder-kpi.component.css']
})
export class PmTechnicalSuborderKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi4: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  PmTechnicalSuborderKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi3: boolean = false;
  manfMonthFilterKpi3: monthFilter;

  Highcharts = Highcharts;

  totalDataPM: any;
  totalDataKpiChartOptionsPM: Highcharts.Options;
  panelWiseDataPM: any;
  panelWiseKpiChartOptionsPM: Highcharts.Options;

  
  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-4', this.isManfMonthFilterSelectedKpi3 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi3) {
      this._dataService.setCookie('s-manfmonth-val-kpi-4', this.manfMonthFilterKpi3.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-4');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi3 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-4');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi3 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi3 == null) {
      this.manfMonthFilterKpi3 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi4 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi3 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi3 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpPmTechnicalSuborderKpi: Array<UiFunctionalKPI> = [];

    let _totalQtyPM: number = 0;
    let _delayQtyPM: number = 0;
    let _onTimeQtyPM: number = 0;
    let _delayQtyPMZS1: number = 0;
    let _onTimeQtyPMZS1: number = 0;
    let _delayQtyPMZS1DBB: number = 0;
    let _onTimeQtyPMZS1DBB: number = 0;
    let _delayQtyPMZS2: number = 0;
    let _onTimeQtyPMZS2: number = 0;
    let _delayQtyPMZS9: number = 0;
    let _onTimeQtyPMZS9: number = 0;
    let _delayQtyPMZN1: number = 0;
    let _onTimeQtyPMZN1: number = 0;

   

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi4.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi4[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            

            // Check for Drawing Approval planned and Actual Dates      

            if (_tmpSSO.pmTechSubSalesOrder.plannedDrawingApprovalDate != null && _tmpSSO.pmTechSubSalesOrder.actualDrawingApprovalDate != null) {


              // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyPM += temp;
                }
              }
            });

            let isRevisedPM = _tmpSSO.pmTechSubSalesOrder.plannedDrawingApprovalDateIsRevised;

              let _pMPlanned = _tmpSSO.pmTechSubSalesOrder.plannedDrawingApprovalDate.getTime();
              let _pMActual = _tmpSSO.pmTechSubSalesOrder.actualDrawingApprovalDate.getTime();
              let _pMDiff_time = _pMPlanned - _pMActual;
              let _pMDiff = _pMDiff_time / (1000 * 3600 * 24);

              // Drawing Approval Delay
              if (_pMDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyPM += temp;
                    }
                  }
                });

                let _individualDelayQtyPM = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPMZS1 += temp;
                          _individualDelayQtyPM += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPMZS1DBB += temp;
                          _individualDelayQtyPM += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPMZS2 += temp;
                          _individualDelayQtyPM += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPMZN1 += temp;
                          _individualDelayQtyPM += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPMZS9 += temp;
                          _individualDelayQtyPM += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedPM == true? null: _tmpSSO.pmTechSubSalesOrder.plannedDrawingApprovalDate;
                let _revisedTmp = isRevisedPM == false? null:_tmpSSO.pmTechSubSalesOrder.plannedDrawingApprovalDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'PM',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyPM, _plannedTmp, _revisedTmp, null, _tmpSSO.pmTechSubSalesOrder.actualDrawingApprovalDate, _pMDiff, _tmpSSO.pmTechSubSalesOrder.actualDrawingApprovalToken.addNotes)

                _tmpPmTechnicalSuborderKpi.push(_tmpSSOobj);
              }
              // Drawing Approval on Time
              if (_pMDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyPM += temp;
                    }
                  }
                });

                let _individualOnTimeQtyPM = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPMZS1 += temp;
                          _individualOnTimeQtyPM += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPMZS1DBB += temp;
                          _individualOnTimeQtyPM += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPMZS2 += temp;
                          _individualOnTimeQtyPM += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPMZN1 += temp;
                          _individualOnTimeQtyPM += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPMZS9 += temp;
                          _individualOnTimeQtyPM += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedPM == true? null: _tmpSSO.pmTechSubSalesOrder.plannedDrawingApprovalDate;
                let _revisedTmp = isRevisedPM == false? null:_tmpSSO.pmTechSubSalesOrder.plannedDrawingApprovalDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'PM',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyPM, _plannedTmp, _revisedTmp, null, _tmpSSO.pmTechSubSalesOrder.actualDrawingApprovalDate, _pMDiff, _tmpSSO.pmTechSubSalesOrder.actualDrawingApprovalToken.addNotes)

                _tmpPmTechnicalSuborderKpi.push(_tmpSSOobj);
              }


            }



            


            

          });

        }


      }

    }

    if (_totalQtyPM != 0 || _onTimeQtyPM != 0 || _delayQtyPM != 0) {
      this.totalDataPM = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyPM,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyPM,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyPM,
        }]
      }

      ];
    }
    else { this.totalDataPM = null; }

    this.totalDataKpiChartOptionsPM = this._kpiCharServ.getTotalDataChartOptions(this.totalDataPM);

    if (_onTimeQtyPMZN1 != 0 || _onTimeQtyPMZS9 != 0 || _onTimeQtyPMZS1 != 0 || _onTimeQtyPMZS1DBB != 0 || _onTimeQtyPMZS2 != 0
      || _delayQtyPMZN1 != 0 || _delayQtyPMZS9 != 0 || _delayQtyPMZS1 != 0 || _delayQtyPMZS1DBB != 0 || _delayQtyPMZS2 != 0) {

      this.panelWiseDataPM = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyPMZN1, _onTimeQtyPMZS9, _onTimeQtyPMZS1, _onTimeQtyPMZS1DBB, _onTimeQtyPMZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyPMZN1, _delayQtyPMZS9, _delayQtyPMZS1, _delayQtyPMZS1DBB, _delayQtyPMZS2],
      }

      ];
    }
    else { this.panelWiseDataPM = null; }

    this.panelWiseKpiChartOptionsPM = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataPM);

    

    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.PmTechnicalSuborderKpi = _tmpPmTechnicalSuborderKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi3 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi3) {
      return this.manfMonthFilterKpi3.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi3) {
      return this.manfMonthFilterKpi3.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi3.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi3.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi3.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi3.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi3 == true && this.manfMonthFilterKpi3 != null) {
      if (this.manfMonthFilterKpi3.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }


}
